// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pz-0";